import classNames from 'classnames'
import React from 'react'

import './Price.css'

const Price = ({ price, size, color, discounted }) => {
    const getPrice = () => {
        return price?.toLocaleString('fa') ?? 0
    }

    return (
        <div
            className={classNames('price', {
                ['price--' + size]: size,
                ['price--' + color]: color,
                'price--discounted': discounted,
            })}
        >
            <span className="price__value">{getPrice()}</span>
            <span className="price__suffix">تومان</span>
        </div>
    )
}

export default Price
